import q from '../query';
import * as api from '../api/collectors';
export const collectorKey = (id) => `collectors-${id}`;
export const useCollector = (id) => q.query(collectorKey(id), () => api.getById(id), [], {
    enabled: id != null,
});
export const allCollectorsKey = () => `all-collectors`;
export const useAllCollectors = () => q.query(allCollectorsKey(), () => api.getAll(), []);
//# sourceMappingURL=index.js.map